const sopOrderProcessingHtml = `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Order Processing SOP</title>
  <style>
    *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
    body { background: #dde1e7; font-family: Arial, Helvetica, sans-serif; padding: 24px 0 40px; }
    .page { width: 1122px; min-height: 794px; background: #ffffff; margin: 0 auto 28px; display: flex; flex-direction: column; box-shadow: 0 2px 12px rgba(0,0,0,0.18); position: relative; }
    .nav { height: 28px; background: #0040B0; display: flex; align-items: center; justify-content: space-between; padding: 0 22px 0 0; flex-shrink: 0; position: relative; }
    .nav-accent { width: 20px; height: 100%; flex-shrink: 0; margin-right: 14px; background: transparent; }
    .nav-left { font-size: 7.5px; font-weight: 700; color: #ffffff; letter-spacing: 0.06em; text-transform: uppercase; }
    .nav-right { font-size: 7.5px; font-weight: 400; color: #ffffff; letter-spacing: 0.06em; text-transform: uppercase; }
    .content { flex: 1; padding: 38px 50px 20px; display: flex; flex-direction: column; }
    .content.continuation { padding-top: 28px; }
    .accent-line { height: 0px; width: 100%; margin-bottom: 18px; }
    .section-title { font-size: 23px; font-weight: 800; color: #1c2b4a; letter-spacing: 0.01em; text-transform: uppercase; margin-bottom: 6px; line-height: 1.1; }
    .section-subtitle { font-size: 16px; color: #7b8499; margin-bottom: 20px; font-weight: 400; }
    table { width: 100%; border-collapse: collapse; font-size: 14px; border: 1px solid #c8d4e8; table-layout: fixed; }
    col.c-scenario { width: 24%; }
    col.c-condition { width: 43%; }
    col.c-decision { width: 20%; }
    col.c-tier { width: 13%; }
    thead tr th { background: #0040B0; color: #ffffff; font-weight: 700; font-size: 14px; padding: 11px 13px; text-align: left; vertical-align: middle; border-right: 1px solid #c8d4e8; letter-spacing: 0.01em; }
    thead tr th:last-child { border-right: none; }
    tbody tr td { padding: 11px 13px; vertical-align: top; border-right: 1px solid #c8d4e8; border-bottom: 1px solid #c8d4e8; line-height: 1.55; font-size: 14px; color: #1a1a2e; }
    tbody tr:last-child td { border-bottom: none; }
    tbody tr td:last-child { border-right: none; }
    td.scenario { font-family: 'Courier New', Courier, monospace; font-weight: 700; font-size: 13px; color: #1c2b4a; vertical-align: top; }
    .highlighted { background-color: #fef9e7; }
    .auto-closed { color: #939fb6; font-style: italic; }
    .note-box { background: #fef9e7; border: 1px solid #f0d9a8; border-radius: 6px; padding: 12px 14px; margin: 16px 0; font-size: 13px; line-height: 1.6; }
    .note-title { font-weight: 700; color: #a16207; margin-bottom: 6px; }
  </style>
</head>
<body>

<div class="page">
  <div class="nav"><div style="display:flex;align-items:center;height:100%;"><div class="nav-accent"></div><span class="nav-left">O2C-OPS Standard</span></div><span class="nav-right">Credit Scenario Dispatch</span></div>
  <div class="content">
    <div class="accent-line"></div>
    <div class="section-title">Scenario Dispatch — Credit</div>
    <div class="section-subtitle">Order Processing Exception Management Standard · v0.1</div>
    <table><colgroup><col class="c-scenario"><col class="c-condition"><col class="c-decision"><col class="c-tier"></colgroup>
      <thead><tr><th>Scenario</th><th>Condition</th><th>Decision</th><th>Tier</th></tr></thead>
      <tbody>
        <tr><td class="scenario">CR_WITHIN_LIMIT</td><td>Exposure ≤ 100% of limit, no adverse signal</td><td>AUTO_RELEASE</td><td>—</td></tr>
        <tr><td class="scenario">CR_TOLERANCE_BAND</td><td>Exposure 100–110%, clean aging, days-to-pay stable</td><td>AUTO_RELEASE</td><td>—</td></tr>
        <tr><td class="scenario">CR_OVER_LIMIT_CLEAN</td><td>Exposure 110–150%, no aging deterioration</td><td>ESCALATE</td><td>T2</td></tr>
        <tr class="highlighted"><td class="scenario">CR_AGING_DETERIORATION</td><td>Any balance in 61–90 bucket, or days-to-pay worsened > 25% over 12 months</td><td>ESCALATE</td><td>T2</td></tr>
        <tr><td class="scenario">CR_SEVERE_EXPOSURE</td><td>Exposure 150–200%</td><td>ESCALATE</td><td>T3</td></tr>
        <tr><td class="scenario">CR_CRITICAL_EXPOSURE</td><td>Exposure > 200%, or order > $100,000</td><td>ESCALATE</td><td>T4</td></tr>
        <tr><td class="scenario">CR_NO_HISTORY</td><td>No credit limit on file, or account under 90 days old</td><td>CREDIT_APPLICATION</td><td>—</td></tr>
        <tr><td class="scenario">CR_BLOCKING</td><td>Any 90+ balance, active collections, returned payment in 90 days</td><td>HOLD</td><td>T3 to override</td></tr>
      </tbody>
    </table>

    <div class="note-box">
      <div class="note-title">Matched Branch: CR_AGING_DETERIORATION</div>
      Days-to-pay moved 32 → 47 over 12 months, a 47% deterioration, and $9,410 sits in the 61–90 bucket. Either condition alone triggers this branch. Tolerance band resolved to 0% — the 61+ balance in the last six months voids the 3-year tenure allowance.
    </div>

    <div style="margin-top: 20px;">
      <h4 style="font-size: 15px; font-weight: 700; color: #1c2b4a; margin-bottom: 8px;">Partial Release Rule</h4>
      <p style="font-size: 13px; line-height: 1.6; color: #4b5563;">
        Where a scenario resolves to ESCALATE and no blocking signal is present, credit_check must compute a partial release that brings exposure back to 100% of limit, and name the specific invoice whose payment would clear the balance.
      </p>
    </div>
  </div>
</div>

<div class="page">
  <div class="nav"><div style="display:flex;align-items:center;height:100%;"><div class="nav-accent"></div><span class="nav-left">O2C-OPS Standard</span></div><span class="nav-right">Tolerance Bands</span></div>
  <div class="content continuation">
    <div class="section-title">Tolerance Bands</div>
    <div class="section-subtitle">Credit exposure tolerance by customer tenure and payment record</div>
    <table><colgroup><col style="width: 25%;"><col style="width: 40%;"><col style="width: 35%;"></colgroup>
      <thead><tr><th>Tenure</th><th>Payment Record</th><th>Tolerance</th></tr></thead>
      <tbody>
        <tr><td>< 12 months</td><td>Any</td><td>0%</td></tr>
        <tr><td>1–3 years</td><td>Clean, stable</td><td>5%</td></tr>
        <tr><td>3+ years</td><td>Clean, stable</td><td>10%</td></tr>
        <tr class="highlighted"><td>3+ years</td><td>Any 61+ balance in last 6 months</td><td>0%</td></tr>
        <tr><td>Any</td><td>Returned payment in last 90 days</td><td>0%</td></tr>
      </tbody>
    </table>
  </div>
</div>

<div class="page">
  <div class="nav"><div style="display:flex;align-items:center;height:100%;"><div class="nav-accent"></div><span class="nav-left">O2C-OPS Standard</span></div><span class="nav-right">Item Master Dispatch</span></div>
  <div class="content">
    <div class="accent-line"></div>
    <div class="section-title">Scenario Dispatch — Item Master</div>
    <div class="section-subtitle">Order Processing Exception Management Standard · v0.1</div>
    <table><colgroup><col class="c-scenario"><col style="width: 33%;"><col style="width: 43%;"></colgroup>
      <thead><tr><th>Scenario</th><th>Condition</th><th>Action</th></tr></thead>
      <tbody>
        <tr><td class="scenario">IM_MATCHED</td><td>Resolved, confidence ≥ 0.90, no substitution</td><td>Accept line</td></tr>
        <tr class="highlighted"><td class="scenario">IM_SUPERSEDED</td><td>Part discontinued, direct replacement exists</td><td>Substitute, record substitution_from, state what changed</td></tr>
        <tr><td class="scenario">IM_MULTI_CANDIDATE</td><td>Two or more candidates above 0.75</td><td>NEEDS_REVIEW, list candidates</td></tr>
        <tr><td class="scenario">IM_LOW_CONFIDENCE</td><td>Extraction confidence below 0.60</td><td>NEEDS_REVIEW, cite unreadable field</td></tr>
        <tr><td class="scenario">IM_DISCONTINUED_NO_SUB</td><td>Discontinued, no replacement on file</td><td>NEEDS_REVIEW</td></tr>
        <tr><td class="scenario">IM_PRICE_VARIANCE</td><td>Quoted price differs from contract list by > 5%</td><td>Flag, continue, do not override</td></tr>
        <tr><td class="scenario">IM_NO_STOCK</td><td>Ship-from branch has no stock</td><td>Suggest alternate branch</td></tr>
      </tbody>
    </table>

    <div class="note-box">
      <div class="note-title">Resolution Routing</div>
      Two failure modes, kept distinct. IM_LOW_CONFIDENCE means the character could not be read — a human looks at the source document. IM_MULTI_CANDIDATE and IM_DISCONTINUED_NO_SUB mean the read was clean but does not resolve — a human makes a product decision. These route to different people.
    </div>
  </div>
</div>

</body>
</html>`;

export default sopOrderProcessingHtml;
